import { InteractionRequiredAuthError } from '@azure/msal-browser';
import msalInstance from '../components/entra/msalInstance';
import { accessTokenRequest } from '../entraConfig';

const getAccessToken = async () => {
  let account = msalInstance.getActiveAccount();

  if (!account) {
    const accounts = msalInstance.getAllAccounts();
    account = accounts.length ? accounts[0] : null;

    if (account) {
      msalInstance.setActiveAccount(account);
    }
  }

  if (!account) {
    window.location.reload();
    return null;
  }

  const request = {
    ...accessTokenRequest,
    account,
  };

  try {
    const response = await msalInstance.acquireTokenSilent(request);
    return response.accessToken;
  } catch (error) {
    console.log('failed to get token', error);

    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect(request);
      return null;
    }

    throw error;
  }
};

export default getAccessToken;
